import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...props}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal — use ONLY for short, single-word lines (clips overflow).
export const MaskedLines = ({ lines = [], className = "", lineClassName = "", start = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: start + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Per-line slide+fade reveal WITHOUT clipping — safe for long lines that wrap.
export const RevealLines = ({ lines = [], className = "", lineClassName = "", start = 0, immediate = false }) => (
  <span className={className}>
    {lines.map((line, i) => {
      const anim = { y: 0, opacity: 1 };
      const trans = { duration: 0.8, delay: start + i * 0.1, ease: [0.22, 1, 0.36, 1] };
      return (
        <motion.span
          key={i}
          className={`block ${lineClassName}`}
          initial={{ y: 30, opacity: 0 }}
          {...(immediate ? { animate: anim } : { whileInView: anim, viewport: { once: true } })}
          transition={trans}
        >
          {line}
        </motion.span>
      );
    })}
  </span>
);
